<template>
  <a-form
    id="formChangePassword"
    class="user-layout-change-password"
    :form="form"
  >
    <a-row class="content-panle margin-0 padding-tb-0" :gutter="24">
      <a-col :span="16" class="padding-tb-md">
        <h3 class="panle-head" style="margin-bottom:16px">
          {{ $t('userCenter.refreshIntervalTitle') }}
        </h3>
        <!-- 访客/人员进出数据刷新时间 -->
        <a-col :span="24">
          <a-form-item :label="$t('userCenter.dataRefreshInterval')">
            <a-input-number
              style="width: 95%"
              :placeholder="$t('userCenter.refreshIntervalTxt')"
              :min="2"
              :max="3600"
              v-decorator="[
                'recordRefreshTimer',
                {
                  initialValue: recordRefreshTimer,
                  rules: [
                    {
                      required: true,
                      message: $t('userCenter.refreshIntervalBlank')
                    }
                  ]
                }
              ]"
              @change="value => (recordRefreshTimer = value)"
            >
            </a-input-number>
            <span class="ant-form-text" style="padding-right:0">
              {{ $t('userCenter.intervalUnit') }}
            </span>
          </a-form-item>
        </a-col>
        <!-- 访客/人员进出数据刷新时间 -->
        <a-col :span="24">
          <a-form-item :label="$t('userCenter.lineRefreshInterval')">
            <a-input-number
              style="width: 95%"
              :placeholder="$t('userCenter.refreshIntervalTxt')"
              :min="60"
              :max="600"
              v-decorator="[
                'recordLineRefreshTimer',
                {
                  initialValue: recordLineRefreshTimer,
                  rules: [
                    {
                      required: true,
                      message: $t('userCenter.refreshIntervalBlank')
                    }
                  ]
                }
              ]"
              @change="value => (recordLineRefreshTimer = value)"
            >
            </a-input-number>
            <span class="ant-form-text" style="padding-right:0">
              {{ $t('userCenter.intervalUnit') }}
            </span>
          </a-form-item>
        </a-col>
        <!-- 其他统计数据刷新时间 -->
        <a-col :span="24">
          <a-form-item :label="$t('userCenter.otherRefreshInterval')">
            <a-input-number
              style="width: 95%"
              :placeholder="$t('userCenter.refreshIntervalTxt')"
              :min="60"
              :max="600"
              v-decorator="[
                'otherRefreshTimer',
                {
                  initialValue: otherRefreshTimer,
                  rules: [
                    {
                      required: true,
                      message: $t('userCenter.refreshIntervalBlank')
                    }
                  ]
                }
              ]"
              @change="value => (otherRefreshTimer = value)"
            >
            </a-input-number>
            <span class="ant-form-text" style="padding-right:0">
              {{ $t('userCenter.intervalUnit') }}
            </span>
          </a-form-item>
        </a-col>

        <a-col :span="24" style="margin-top: 16px;">
          <a-button
            type="primary"
            @click="handleSubmitRefreshInterrval"
            :disabled="submiting"
            :loading="submiting"
          >
            {{ $t('userCenter.submitRefreshTimeBtn') }}
          </a-button>
        </a-col>
      </a-col>
    </a-row>
  </a-form>
</template>

<script>
import { mapState } from 'vuex'
import { getUserConfig, setUserConfig } from '@/api/userMana'

export default {
  name: 'userCenterRefreshInterval',
  components: {},
  data() {
    return {
      form: this.$form.createForm(this),
      submiting: false,

      recordRefreshTimer: '10',
      recordLineRefreshTimer: '60',
      otherRefreshTimer: '60'
    }
  },
  created() {
    this.getRefreshInterrval()
  },
  deactivated() {
    // this.form.resetFields()
  },
  computed: {
    ...mapState(['userInfo', 'lang'])
  },
  methods: {
    // 获取基本设置
    async getRefreshInterrval() {
      try {
        const res = await getUserConfig()
        const {
          recordStatisticRefreshIntervalSecond,
          recordRefreshIntervalSecond,
          otherStatisticRefreshIntervalSecond
        } = res.data.collection[0]

        this.recordRefreshTimer = Number(recordStatisticRefreshIntervalSecond)
        this.recordLineRefreshTimer = Number(recordRefreshIntervalSecond)
        this.otherRefreshTimer = Number(otherStatisticRefreshIntervalSecond)
      } catch (error) {}
    },
    // 提交基本设置
    handleSubmitRefreshInterrval(e) {
      this.form.validateFields(async (err, values) => {
        // console.log('------handleSubmitRefreshInterrval-------', err, values)
        if (!err) {
          try {
            this.submiting = true
            // setUserConfig 不能并发提交，不然可能会导致某些修改失效
            await setUserConfig({
              key: 'recordStatisticRefreshIntervalSecond',
              value: values.recordRefreshTimer.toString()
            })
            await setUserConfig({
              key: 'recordRefreshIntervalSecond',
              value: values.recordLineRefreshTimer.toString()
            })
            await setUserConfig({
              key: 'otherStatisticRefreshIntervalSecond',
              value: values.otherRefreshTimer.toString()
            })
            this.submiting = false

            this.$notification.success({
              message: this.$t('userCenter.setBasicSuccess'),
              description: ''
            })
          } catch (error) {
            this.submiting = false
          }
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.list-title {
  color: #262626;
}
</style>
